<template>
  <div class="Info">
    <div class="title">{{title}}</div>
    <div class="panel">
      <p>
        获取题目后则表示答题开始，请在规定的时间内完成答题并提交答卷，过时则代表放弃该次活动。
      </p>
        您当前已持有AI HackStack 使用许可证，您可以登录AI HackStack ，通过AI HackStack来帮助您回答问题和方案设计。
      <br/>
        许可证使用时限如下：
      <br/>
        晋级决赛选手：初赛支付成功后1个月 + 决赛开始后1个月（若时间段重叠，以7月1号为最终结束时间）。
      <br/>
       未晋级决赛选手：初赛支付成功后1个月 + 初赛结束后1个月（若时间段重叠，以6月15号为最终结束时间）。
      <br/>
        点击登录AI HackStack？
    </div>
    <div class="button">
      <my_button value="立即获取" @click.native="start"></my_button>
    </div>
  </div>
</template>

<script>
import MyButton from '@/components/Button.vue';
 export default {
   name: 'Info',
   components: {
    my_button: MyButton
   },
   data () {
     return {
     }
   },
   methods: {
     start () {
       this.$http.post('/api/rank').then(res => {
         this.$router.push({name: 'contest'})
       })
     }
   },
   computed: {
     title() {
       return '获取题目'
     },
   },
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Info{
   box-sizing: border-box;
   border-radius: 1vw;

   display: flex;
   flex-direction: column;
   align-items:center;
   justify-content: space-between;
 }
 .title{
   font-size: 1.875vw;
   line-height: 6.85vw;
   display: flex;
   align-items:center;
   justify-content: center;

   width: 100%;
 }
 .panel{
   width: 80%;
   display: flex;
   justify-content:space-between;
   flex-direction: column;
 }

 .button{
   width: 7.6vw;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   position: relative;
   margin: 2vw 0;
 }

</style>
